if ($('body').hasClass('page-template-lenders-onboarding')) {
  let lenderOnboarding = {};
  $(function () {
    const signupArgs = {
      controller: $('section.signup').attr('data-controller'),
      GETparams: JSON.parse( $('section.signup').attr('data-qparams') ),
      language: $('section.signup').attr('data-language'),
      agreements: $('section.signup').attr('data-agreements'),
    };

    lenderOnboarding = new LenderOnboarding(signupArgs);
  });
}
